export default "__VITE_ASSET__D0qFyQou__"